import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  public connect(): void {
    window.NProgress.configure({ parent: `#${this.element.id}` })
  }
}
